export default {
  "overview": {
    "title": "Visão Geral do CRM",
    "description": "Candidatos entregues ao cliente no período selecionado; sem filtro, todo o histórico."
  },
  "qualification": {
    "title": "Qualificação",
    "description": "Candidatos visíveis por data de admissão e origem; sem filtro, todo o histórico."
  },
  "prospecting": {
    "title": "Prospecção",
    "description": "Aquisição de candidatos visíveis por data de admissão e origem; sem filtro, todo o histórico."
  },
  "monitoring": {
    "title": "Monitoramento do Scanner",
    "description": "Retrato global atual das filas, etapas, buscas de contato e cache semântico do CRM."
  },
  "metrics": {
    "delivered": "Entregues",
    "qualified": "Qualificados nas Offers",
    "notQualified": "Não qualificados",
    "qualificationRate": "Taxa de qualificação nas Offers",
    "undecided": "Sem decisão",
    "averageScore": "Score médio",
    "averageCoverage": "Cobertura média",
    "directContactTitle": "contato direto",
    "prospectsDirect": "Prospects com contato direto",
    "prospectsInstitutional": "Prospects só com canal institucional",
    "directSearchPending": "Busca de contato direto pendente",
    "directSearchWithoutResult": "Busca concluída sem contato direto",
    "routeIdentified": "Rota de compra identificada",
    "routePartial": "Rota de compra parcial",
    "agentscanCost": "Custo estimado: enriquecimento",
    "contactscanCost": "Custo estimado: busca de contato",
    "offerContractCost": "Custo estimado: contrato das Offers",
    "scoreQualified": "Score ≥ 60 (avaliação atual)",
    "directContact": "Com contato direto",
    "scoreQualifiedDirect": "Score ≥ 60 e contato direto",
    "historicalOnly": "Só avaliação anterior",
    "institutional": "Contato Institucional",
    "na": "Contato N/A",
    "total": "Total",
    "midscanApproved": "Enriquecidos (AgentScan)",
    "hiscanQualified": "Qualificados nas Offers",
    "contactFound": "Canal útil encontrado",
    "candidates": "Candidatos",
    "lowApproved": "Elegíveis",
    "hiscanConversionRate": "Enriquecidos → Qualificados",
    "contactRate": "Qualificados → Prospect",
    "peopleSuccess": "Buscas de contato concluídas",
    "peopleErrors": "Buscas de contato com erro",
    "peopleDue": "Buscas de contato a revalidar",
    "peopleQueries": "Consultas de contato",
    "lowDue": "Aguardando verificação de elegibilidade",
    "midDue": "Aguardando triagem",
    "hiscanEvaluating": "Em avaliação nas Offers",
    "hiscanNotQualified": "Não qualificados nas Offers",
    "semanticProfiles": "Perfis semânticos",
    "offerContracts": "Contratos semânticos de oferta",
    "semanticCost": "Custo semântico estimado",
    "assessed": "Avaliados",
    "offerQualified": "Aderentes à oferta",
    "averageScoreShort": "Score médio",
    "averageCoverageShort": "Cobertura média",
    "prospects": "Prospects",
    "pendingContact": "Pendente de contato",
    "nurturing": "Nutrir",
    "hiscanQualificationRate": "Taxa de qualificação nas Offers",
    "prospectConversionRate": "Qualificados → Prospect",
    "peopleConcluded": "Candidates com busca de contato concluída",
    "evaluating": "Em análise",
    "dossierAvailable": "Dossiês disponíveis",
    "peopleStarted": "Candidates com busca de contato iniciada",
    "lowExecuted": "Elegibilidade verificada",
    "midscanExecuted": "Triagem concluída",
    "hiscanStarted": "Avaliação de Offers iniciada",
    "hiscanCompleted": "Avaliação de Offers concluída"
  },
  "groups": {
    "pipeline": "Pipeline",
    "quality": "Qualidade",
    "rates": "Taxas",
    "qualityAndContact": "Qualidade e contato",
    "contactability": "Contactabilidade",
    "sources": "Origens",
    "offers": "Ofertas",
    "operations": "Operação",
    "queues": "Filas",
    "semantic": "Semântica"
  },
  "charts": {
    "deliveriesByDay": "Entregas por data de entrega",
    "recordedDays": "Somente datas com entregas registradas",
    "contactability": "Distribuição de contactabilidade",
    "qualificationFunnel": "Funil enriquecimento → qualificação",
    "qualificationTrend": "Situação atual por data de admissão",
    "qualificationOffers": "Desempenho por oferta",
    "offerQuality": "Score e cobertura por oferta",
    "prospectingSources": "Entrada, qualificação e Prospects por origem",
    "prospectingFunnel": "Funil de prospecção",
    "sourcePerformance": "Conversão por origem",
    "monitoringStages": "Pipeline do Scanner",
    "monitoringFunnel": "Funil de progressão do Scanner",
    "monitoringQueues": "Backlog operacional",
    "peopleStatus": "Buscas de contato por status",
    "semanticInventory": "Inventário semântico",
    "stateTransitions": "Transições de estado por dia",
    "stateTransitionsHint": "Histórico factual registrado a partir da ativação do ledger de estados; períodos anteriores não são reconstruídos.",
    "disqualificationReasons": "Principais motivos de não qualificação",
    "offerTypes": "Resultado por tipo de oferta",
    "searchSegments": "Resultado por segmento do SearchList",
    "scannerExecutions": "Execuções por etapa do Scanner"
  },
  "cards": {
    "volume": "Volume do pipeline",
    "quality": "Qualidade",
    "contactability": "Contactabilidade",
    "trends": "Tendências",
    "offers": "Desempenho por oferta",
    "sources": "Resultado por origem",
    "operations": "Operação",
    "queues": "Filas",
    "semantic": "Semântica",
    "funnel": "Funil",
    "people": "Busca de contato",
    "history": "Acumulado histórico",
    "daily": "Detalhamento por dia",
    "current": "Estado atual",
    "status": "Situação comercial",
    "scoreAndContact": "Score atual e contato",
    "prospectContact": "Prospects e busca de contato direto",
    "estimatedCost": "Custo estimado (USD)",
    "rates": "Conversões",
    "qualification": "Qualificação",
    "contactGate": "Gate de contato",
    "dossiers": "Dossiês",
    "transitions": "Transições reais",
    "disqualification": "Motivo principal da não qualificação",
    "segments": "Segmentos do SearchList",
    "executions": "Execuções do Scanner"
  },
  "stages": {
    "candidates": "Candidatos",
    "scan_level_1": "Scan - Nível 1",
    "scan_level_2": "Scan - Nível 2",
    "scan_level_3": "Scan - Nível 3",
    "low_approved": "Elegíveis",
    "midscan_approved": "Enriquecidos (AgentScan)",
    "hiscan_qualified": "Qualificados nas Offers",
    "qualified": "Qualificados nas Offers",
    "direct_contact": "contato direto",
    "contact_found": "Contatos encontrados",
    "people_success": "Busca de contato concluída",
    "low_due": "Aguardando elegibilidade",
    "mid_due": "Aguardando triagem",
    "hiscan_evaluating": "Em avaliação nas Offers",
    "people_due": "Aguardando busca de contato",
    "prospect": "Prospects",
    "prospects": "Prospects",
    "pending_contact": "Pendente de contato",
    "nurturing": "Nutrir",
    "not_qualified": "Não qualificados",
    "low_executed": "Elegibilidade verificada",
    "midscan_executed": "Triagem concluída",
    "hiscan_started": "Avaliação de Offers iniciada",
    "hiscan_completed": "Avaliação de Offers concluída",
    "people_started": "Busca de contato iniciada",
    "people_concluded": "Busca de contato concluída"
  },
  "origins": {
    "manual": "Manual",
    "import": "Importação",
    "existing": "Já existente",
    "radar": "Radar",
    "unknown": "Não informada"
  },
  "contactability": {
    "direct": "Direto",
    "institutional": "Institucional",
    "na": "Não disponível"
  },
  "peopleStatuses": {
    "success": "Concluído",
    "error": "Erro",
    "pending": "Pendente",
    "running": "Em execução"
  },
  "semanticKinds": {
    "candidate_profiles": "Perfis de candidatos",
    "offer_contracts": "Contratos de oferta"
  },
  "mini": {
    "total": "Total",
    "rateDecided": "Taxa (decididos)",
    "midscanToHiScan": "Enriquecidos → Qualificados",
    "contactRate": "Contato",
    "contacts": "Contatos",
    "midscan": "Enriquecimento",
    "qualified": "Qualificados nas Offers",
    "commercial": "Comercial",
    "qualifiedDirect": "Qualificados com contato direto",
    "evaluating": "Em avaliação",
    "notQualified": "Não qualificados",
    "queue": "Na fila",
    "success": "Concluídos",
    "errors": "Erros",
    "profiles": "Perfis",
    "contracts": "Contratos",
    "prospects": "Prospects"
  },
  "filters": {
    "deliveryPeriod": "Data da entrega",
    "admissionPeriod": "Data da admissão",
    "origin": "Origem de admissão",
    "period": "Período"
  },
  "columns": {
    "day": "Data da entrega",
    "offer": "Oferta",
    "origin": "Origem",
    "assessed": "Avaliados",
    "qualified": "Qualificados nas Offers",
    "delivered": "Entregues",
    "notQualified": "Não qualificados",
    "score": "Score médio",
    "coverage": "Cobertura média",
    "candidates": "Candidatos",
    "hiscanQualified": "Qualificados nas Offers",
    "prospects": "Prospects",
    "pendingContact": "Pendente de contato",
    "nurturing": "Nutrir",
    "total": "Total",
    "reason": "Motivo",
    "offerType": "Tipo de oferta",
    "segment": "Segmento do SearchList"
  },
  "offerTypes": {
    "product": "Produto",
    "service": "Serviço"
  },
  "disqualificationReasons": {
    "prospect_threshold_not_approved": "Threshold comercial indisponível",
    "lowscan_not_approved": "Elegibilidade não confirmada",
    "coverage_stale": "Coverage desatualizada",
    "coverage_below_gate": "Coverage abaixo do gate",
    "hiscan_not_executed": "Avaliação de Offers não executada",
    "assessment_incomplete": "Avaliação das ofertas incompleta",
    "offer_excluded": "Ofertas excluídas por incompatibilidade de escopo",
    "applicability_missing": "Nenhuma oferta aplicável",
    "score_below_prospect_threshold": "Score abaixo do threshold",
    "reason_not_recorded": "Motivo não registrado"
  }
};
